import { Injectable } from '@angular/core';
import {  MailMessage } from '../_types/mail-message';
import { Service } from 'src/app/core/jsonapi/service';
import { prop } from '@rxweb/reactive-form-validators';

@Injectable({
  providedIn: 'root'
})
export class MailMessageRecipientService extends Service<MailMessage> {
  public override type = 'mailMessageRecipients';
  public override url = 'communications/mailMessageRecipients';
  

}
